import React, { Fragment } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';

import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import Container from '@material-ui/core/Container';
import Toolbar from '@material-ui/core/Toolbar';

const styles = theme=>({
  root: {
    marginBottom: theme.spacing(2),

    '& > h1': {
      marginTop: theme.spacing(4),
    },
    '& > p': {
      marginTop: theme.spacing(2),
    }
  },
});

const Privacy = ({ classes })=>{
  return (
    <Container className={classes.root}>
      <Typography variant="h6" component="h1">
        SEÇÃO 1 - O QUE FAREMOS COM ESTA INFORMAÇÃO?
      </Typography>
      <Typography>
        Quando você realiza alguma transação com nossa loja, como parte do processo de compra e venda, coletamos as informações pessoais que você nos dá tais como: nome, e-mail e endereço.
      </Typography>
      <Typography>
        Quando você acessa nosso site, também recebemos automaticamente o protocolo de internet do seu computador, endereço de IP, a fim de obter informações que nos ajudam a aprender sobre seu navegador e sistema operacional.
      </Typography>
      <Typography variant="h6" component="h1">
        SEÇÃO 2 - CONSENTIMENTO
      </Typography>
      <Typography>
        Como vocês obtêm meu consentimento?
      </Typography>
      <Typography>
        Quando você fornece informações pessoais como nome, telefone e endereço, para completar: uma transação, verificar seu cartão de crédito, fazer um pedido, providenciar uma entrega ou retornar uma compra. Após a realização de ações entendemos que você está de acordo com a coleta de dados para serem utilizados pela nossa empresa.
      </Typography>
      <Typography>
        Se pedimos por suas informações pessoais por uma razão secundária, como marketing, vamos lhe pedir diretamente por seu consentimento, ou lhe fornecer a oportunidade de dizer não.
      </Typography>
      <Typography>
        E caso você queira retirar seu consentimento, como proceder?
      </Typography>
      <Typography>
        Se após você nos fornecer seus dados, você mudar de ideia, você pode retirar o seu consentimento para que possamos entrar em contato, para a coleção de dados contínua, uso ou divulgação de suas informações, a qualquer momento, entrando em contato conosco em contato@knaufisopor.com.br ou nos enviando uma correspondência em: Knauf Isopor Av. Fagundes Filho 141; E 145 Ed Denver; São Paulo
      </Typography>
      <Typography variant="h6" component="h1">
        SEÇÃO 3 - DIVULGAÇÃO
      </Typography>
      <Typography>
        Podemos divulgar suas informações pessoais caso sejamos obrigados pela lei para fazê-lo ou se você violar nossos Termos de Serviço.
      </Typography>
      <Typography variant="h6" component="h1">
        SEÇÃO 4 - SERVIÇOS DE TERCEIROS
      </Typography>
      <Typography>
        No geral, os fornecedores terceirizados usados por nós irão apenas coletar, usar e divulgar suas informações na medida do necessário para permitir que eles realizem os serviços que eles nos fornecem.
      </Typography>
      <Typography>
        Entretanto, certos fornecedores de serviços terceirizados, tais como gateways de pagamento e outros processadores de transação de pagamento, têm suas próprias políticas de privacidade com respeito à informação que somos obrigados a fornecer para eles de suas transações relacionadas com compras.
      </Typography>
      <Typography>
        Para esses fornecedores, recomendamos que você leia suas políticas de privacidade para que você possa entender a maneira na qual suas informações pessoais serão usadas por esses fornecedores.
      </Typography>
      <Typography>
        Em particular, lembre-se que certos fornecedores podem ser localizados em ou possuir instalações que são localizadas em jurisdições diferentes que você ou nós. Assim, se você quer continuar com uma transação que envolve os serviços de um fornecedor de serviço terceirizado, então suas informações podem tornar-se sujeitas às leis da(s) jurisdição(ões) nas quais o fornecedor de serviço ou suas instalações estão localizados.
      </Typography>
      <Typography>
        Como um exemplo, se você está localizado no Canadá e sua transação é processada por um gateway de pagamento localizado nos Estados Unidos, então suas informações pessoais usadas para completar aquela transação podem estar sujeitas a divulgação sob a legislação dos Estados Unidos, incluindo o Ato Patriota.
      </Typography>
      <Typography>
        Uma vez que você deixe o site da nossa loja ou seja redirecionado para um aplicativo ou site de terceiros, você não será mais regido por essa Política de Privacidade ou pelos Termos de Serviço do nosso site.
      </Typography>
      <Typography>
        Links
      </Typography>
      <Typography>
        Quando você clica em links na nossa loja, eles podem lhe direcionar para fora do nosso site. Não somos responsáveis pelas práticas de privacidade de outros sites e lhe incentivamos a ler as declarações de privacidade deles.
      </Typography>
      <Typography variant="h6" component="h1">
        SEÇÃO 5 - SEGURANÇA
      </Typography>
      <Typography>
        Para proteger suas informações pessoais, tomamos precauções razoáveis e seguimos as melhores práticas da indústria para nos certificar que elas não serão perdidas inadequadamente, usurpadas, acessadas, divulgadas, alteradas ou destruídas.
      </Typography>
      <Typography>
        Se você nos fornecer as suas informações de cartão de crédito, essa informação é criptografada usando tecnologia "secure socket layer" (SSL) e armazenada com uma criptografia AES-256. Embora nenhum método de transmissão pela Internet ou armazenamento eletrônico é 100% seguro, nós seguimos todos os requisitos da PCI-DSS e implementamos padrões adicionais geralmente aceitos pela indústria.
      </Typography>
      <Typography variant="h6" component="h1">
        SEÇÃO 6 - ALTERAÇÕES PARA ESSA POLÍTICA DE PRIVACIDADE
      </Typography>
      <Typography>
        Reservamos o direito de modificar essa política de privacidade a qualquer momento, então por favor, revise-a com frequência. Alterações e esclarecimentos vão surtir efeito imediatamente após sua publicação no site. Se fizermos alterações de materiais para essa política, iremos notificá-lo aqui que eles foram atualizados, para que você tenha ciência sobre quais informações coletamos, como as usamos, e sob que circunstâncias, se alguma, usamos e/ou divulgamos elas.
      </Typography>
      <Typography>
        Se nossa loja for adquirida ou fundida com outra empresa, suas informações podem ser transferidas para os novos proprietários para que possamos continuar a vender produtos para você.
      </Typography>
    </Container>
  );
};

const PrivacyWithStyles = withStyles(styles)(Privacy);

export const PrivacyWithHeader = ()=>{
  return (
    <Fragment>
      <AppBar position="static">
        <Container>
          <Toolbar disableGutters>
            <img src="/assets/knauf_logo_branco.png" height="43" alt="Knauf Isopor" />
          </Toolbar>
        </Container>
      </AppBar>
      <PrivacyWithStyles />
    </Fragment>
  )
}

export default PrivacyWithStyles;